// financial.js
import { getOptionsFromMap } from './common';

// Constantes e Labels específicos do módulo Financeiro (Contas a Pagar/Receber)
// Métodos de Pagamento (IDs em string — fonte única de verdade)
export const PAYMENT_METHODS = {
    CASH: 'CASH',
    CREDIT_CARD: 'CREDIT_CARD',
    DEBIT_CARD: 'DEBIT_CARD',
    BOLETO: 'BOLETO',
    PIX: 'PIX',
    VOUCHER: 'VOUCHER',
    CHECK: 'CHECK',
    TRANSFER: 'TRANSFER',
    OTHER: 'OTHER'
};

export const PAYMENT_METHOD_LABELS = {
    [PAYMENT_METHODS.CASH]: 'Dinheiro',
    [PAYMENT_METHODS.CREDIT_CARD]: 'Cartão de Crédito',
    [PAYMENT_METHODS.DEBIT_CARD]: 'Cartão de Débito',
    [PAYMENT_METHODS.BOLETO]: 'Boleto',
    [PAYMENT_METHODS.PIX]: 'PIX',
    [PAYMENT_METHODS.VOUCHER]: 'Voucher/Vale',
    [PAYMENT_METHODS.CHECK]: 'Cheque',
    [PAYMENT_METHODS.TRANSFER]: 'Transferência (TED/DOC)',
    [PAYMENT_METHODS.OTHER]: 'Outro'
};

export const PAYMENT_METHOD_OPTIONS = getOptionsFromMap(PAYMENT_METHODS, PAYMENT_METHOD_LABELS);

export const FINANCIAL_TYPES = {
    INCOME: 'INCOME',
    EXPENSE: 'EXPENSE',
    ASSET: 'ASSET',
    LIABILITY: 'LIABILITY'
};

export const FINANCIAL_TYPE_LABELS = {
    [FINANCIAL_TYPES.INCOME]: 'Receita',
    [FINANCIAL_TYPES.EXPENSE]: 'Despesa',
    [FINANCIAL_TYPES.ASSET]: 'Ativo',
    [FINANCIAL_TYPES.LIABILITY]: 'Passivo'
};

export const FINANCIAL_SOURCES = {
    MEMBER: 'MEMBER',
    ACQUIRER: 'ACQUIRER',
    SUPPLIER: 'SUPPLIER',
    EMPLOYEE: 'EMPLOYEE'
};

export const FINANCIAL_SOURCE_LABELS = {
    [FINANCIAL_SOURCES.MEMBER]: 'Aluno / Cliente',
    [FINANCIAL_SOURCES.ACQUIRER]: 'Adquirente / Gateway',
    [FINANCIAL_SOURCES.SUPPLIER]: 'Fornecedor',
    [FINANCIAL_SOURCES.EMPLOYEE]: 'Colaborador / Instrutor'
};

export const FINANCIAL_STATUS = {
    PENDING: 'PENDING',
    PAID: 'PAID',
    OVERDUE: 'OVERDUE',
    CANCELED: 'CANCELED'
};

export const FINANCIAL_STATUS_LABELS = {
    [FINANCIAL_STATUS.PENDING]: 'Pendente',
    [FINANCIAL_STATUS.PAID]: 'Pago / Recebido',
    [FINANCIAL_STATUS.OVERDUE]: 'Atrasado',
    [FINANCIAL_STATUS.CANCELED]: 'Cancelado / Estornado'
};

// Re-export do global.js — NÃO redefinir aqui!
export const FINANCIAL_PAYMENT_METHODS = PAYMENT_METHODS;
export const FINANCIAL_PAYMENT_METHOD_LABELS = PAYMENT_METHOD_LABELS;

// Cores temáticas para os Status (ex: uso no Tailwind ou UI/UX)
export const FINANCIAL_STATUS_COLORS = {
    [FINANCIAL_STATUS.PENDING]: 'warning',
    [FINANCIAL_STATUS.PAID]: 'success',
    [FINANCIAL_STATUS.OVERDUE]: 'danger',
    [FINANCIAL_STATUS.CANCELED]: 'secondary'
};

// ── Tipos de item de venda (para categorização financeira) ──
export const SALE_ITEM_TYPES = {
    MEMBERSHIP: 'membership',
    PRODUCT: 'product',
    SERVICE: 'service',
    EVENT: 'event'
};

/**
 * Mapa de tipo de item → nome canônico da categoria financeira (DRE).
 * Deve bater EXATAMENTE com as categorias seedadas em financial_category_service.js
 */
export const ITEM_TYPE_TO_CATEGORY = {
    [SALE_ITEM_TYPES.MEMBERSHIP]: 'Mensalidades',
    [SALE_ITEM_TYPES.PRODUCT]: 'Produtos / Bar',
    [SALE_ITEM_TYPES.SERVICE]: 'Serviços Avulsos',
    [SALE_ITEM_TYPES.EVENT]: 'Eventos'
};
